// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Custom styles for Settlement Details */
.settlement-container {
  height: 100vh;
  background-color: #f8f9fa;
}

.order-sidebar {
  min-width: 250px !important;
  background: white;
  border-right: 1px solid #dee2e6;
  overflow-y: auto;
}

.order-item {
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f8f9fa;
}

.order-item:hover {
  background-color: #f8f9fa;
}

.order-item.active {
  background-color: rgba(13, 110, 253, 0.1);
  border-left: 4px solid #0d6efd;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid;
}

.status-settled {
  color: #198754;
}

.status-processing {
  background-color: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
}

.status-pending {
  color: #ffc107;
}

.status-failed {
  color: #dc3545;
}

.status-shipped {
  color: #0dcaf0;
}

.error-message-badge {
  color: #856404;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050; /* Ensure it appears on top of other content */
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 300px;
  max-height: 90vh; /* Optional: limits the modal's height */
  overflow-y: auto; /* Adds scroll if the content overflows */
}

.loading-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.settlement-overview-label {
  font-size: 16px;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.settlement-overview-value {
  font-size: 0.875rem;
}

.amount-highlight {
  color: #198754 !important;
  font-weight: 600;
}

.card-custom {
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.btn-refresh {
  background: linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%);
  border: none;
  color: white;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-refresh:hover {
  transform: translateY(-1px);
  box-shadow: 0 0.25rem 0.5rem rgba(13, 110, 253, 0.3);
}

.btn-refresh:disabled {
  opacity: 0.6;
  transform: none;
}

.errorMessage{
  line-height: 1px;
  border: 1px solid #c4bdbd;
  border-radius: 5px;
  padding: 5px;
  color: #856404;
}

.clearFilter {
  background-color: #f0f2f5;
  border: 1px solid #dadee2;
  color: #495057;
  font-size: 0.875rem; /* Slightly increase the font size for better readability */
  padding: 6px 12px;
  border-radius: 8px; /* Slightly rounded for a smoother look */
  font-weight: 500;
  text-align: center;
  transition: background-color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease; /* Added transition for scaling effect */
  cursor: pointer; /* Indicating it's clickable */
}

.clearFilter:hover {
  background-color: #e2e6ea;
  color: #212529;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12); /* Soft shadow for better hover effect */
  transform: scale(1.05); /* Slight scaling effect to make it feel interactive */
}

.clearFilter:active {
  background-color: #dae0e5; /* Darker background on active click */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* Slightly deeper shadow when clicked */
  transform: scale(0.98); /* Slight shrink when button is pressed */
}

@media (max-width: 768px) {
  .order-sidebar {
    width: 100%;
    max-height: 300px;
  }
  
  .settlement-container {
    flex-direction: column;
  }
}


`, "",{"version":3,"sources":["webpack://./src/containers/Settlements/SettlementDetails.css"],"names":[],"mappings":";AACA,yCAAyC;AACzC;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B,EAAE,gCAAgC;EAChE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,8CAA8C;AAC/D;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB,EAAE,wCAAwC;EAC1D,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,mBAAmB,EAAE,2DAA2D;EAChF,iBAAiB;EACjB,kBAAkB,EAAE,yCAAyC;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,iFAAiF,EAAE,wCAAwC;EAC3H,eAAe,EAAE,8BAA8B;AACjD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yCAAyC,EAAE,wCAAwC;EACnF,sBAAsB,EAAE,sDAAsD;AAChF;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,yCAAyC,EAAE,wCAAwC;EACnF,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["\n/* Custom styles for Settlement Details */\n.settlement-container {\n  height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.order-sidebar {\n  min-width: 250px !important;\n  background: white;\n  border-right: 1px solid #dee2e6;\n  overflow-y: auto;\n}\n\n.order-item {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid #f8f9fa;\n}\n\n.order-item:hover {\n  background-color: #f8f9fa;\n}\n\n.order-item.active {\n  background-color: rgba(13, 110, 253, 0.1);\n  border-left: 4px solid #0d6efd;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 50px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  border: 1px solid;\n}\n\n.status-settled {\n  color: #198754;\n}\n\n.status-processing {\n  background-color: rgba(13, 110, 253, 0.1);\n  color: #0d6efd;\n}\n\n.status-pending {\n  color: #ffc107;\n}\n\n.status-failed {\n  color: #dc3545;\n}\n\n.status-shipped {\n  color: #0dcaf0;\n}\n\n.error-message-badge {\n  color: #856404;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1050; /* Ensure it appears on top of other content */\n}\n\n.modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 5px;\n  width: 300px;\n  max-height: 90vh; /* Optional: limits the modal's height */\n  overflow-y: auto; /* Adds scroll if the content overflows */\n}\n\n.loading-spinner {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.settlement-overview-label {\n  font-size: 16px;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.settlement-overview-value {\n  font-size: 0.875rem;\n}\n\n.amount-highlight {\n  color: #198754 !important;\n  font-weight: 600;\n}\n\n.card-custom {\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.btn-refresh {\n  background: linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%);\n  border: none;\n  color: white;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.btn-refresh:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 0.25rem 0.5rem rgba(13, 110, 253, 0.3);\n}\n\n.btn-refresh:disabled {\n  opacity: 0.6;\n  transform: none;\n}\n\n.errorMessage{\n  line-height: 1px;\n  border: 1px solid #c4bdbd;\n  border-radius: 5px;\n  padding: 5px;\n  color: #856404;\n}\n\n.clearFilter {\n  background-color: #f0f2f5;\n  border: 1px solid #dadee2;\n  color: #495057;\n  font-size: 0.875rem; /* Slightly increase the font size for better readability */\n  padding: 6px 12px;\n  border-radius: 8px; /* Slightly rounded for a smoother look */\n  font-weight: 500;\n  text-align: center;\n  transition: background-color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease; /* Added transition for scaling effect */\n  cursor: pointer; /* Indicating it's clickable */\n}\n\n.clearFilter:hover {\n  background-color: #e2e6ea;\n  color: #212529;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12); /* Soft shadow for better hover effect */\n  transform: scale(1.05); /* Slight scaling effect to make it feel interactive */\n}\n\n.clearFilter:active {\n  background-color: #dae0e5; /* Darker background on active click */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* Slightly deeper shadow when clicked */\n  transform: scale(0.98); /* Slight shrink when button is pressed */\n}\n\n@media (max-width: 768px) {\n  .order-sidebar {\n    width: 100%;\n    max-height: 300px;\n  }\n  \n  .settlement-container {\n    flex-direction: column;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
